
import { Card, CardContent } from '@/components/ui/card';
import { Code, TrendingUp, Search, Users, BarChart3, Zap } from 'lucide-react';

const EthicalUseCases = () => {
  const ethicalUseCases = [
    {
      icon: <Code className="h-5 w-5 text-blue-600" />,
      title: "Web Development & Testing",
      description: "Test websites from different locations and verify geo-targeting."
    },
    {
      icon: <TrendingUp className="h-5 w-5 text-green-600" />,
      title: "Market Research",
      description: "Gather competitive intelligence and analyze market trends."
    },
    {
      icon: <Search className="h-5 w-5 text-purple-600" />,
      title: "SEO & SERP Monitoring",
      description: "Track search rankings and monitor SEO performance."
    },
    {
      icon: <Users className="h-5 w-5 text-orange-600" />,
      title: "Social Media Management",
      description: "Manage accounts and analyze regional engagement."
    },
    {
      icon: <BarChart3 className="h-5 w-5 text-red-600" />,
      title: "Data Analytics",
      description: "Collect public data for business intelligence."
    },
    {
      icon: <Zap className="h-5 w-5 text-yellow-600" />,
      title: "Automation & Workflows",
      description: "Automate legitimate business processes efficiently."
    }
  ];

  return (
    <div className="mb-4">
      <div className="text-center mb-3">
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          Ethical Usage Cases
        </h2>
        <p className="text-sm text-gray-600">
          Our services are designed for legitimate business needs
        </p>
      </div>

      <div className="grid md:grid-cols-6 gap-3">
        {ethicalUseCases.map((useCase, index) => (
          <Card key={index} className="group hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-200 hover:border-green-400 bg-white">
            <CardContent className="p-3 text-center">
              <div className="flex justify-center mb-2">
                <div className="bg-gray-100 rounded-lg p-2 group-hover:bg-green-50 transition-colors duration-300">
                  {useCase.icon}
                </div>
              </div>
              <h3 className="text-xs font-bold text-gray-900 mb-1">{useCase.title}</h3>
              <p className="text-xs text-gray-600">{useCase.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default EthicalUseCases;
